const csv_props = {
	Name: {
		slug: "name"
	},
	Latitude: {
		slug: "lat",
		position: true
	},
	Longitude: {
		slug: "lng",
		position: true
	},
	"PV Category": {
		slug: "pv_category"
	},
	"Peak Power (kWp)": {
		slug: "peak_power",
		pv_data: true
	},
	Tracking: {
		slug: "tracking",
		pv_data: true,
		default: "Fixed"
	},
	"Tilt (º)": {
		slug: "tilt",
		pv_data: true
	},
	"Azimuth(º)": {
		slug: "azimuth",
		pv_data: true
	},
	"Losses (%)": {
		slug: "losses",
		pv_data: true
	}
};

const LocationValidator = require("../classes/location");
var moment = require("moment");

export default {
	export_locations(locations) {
		var headers = [];
		for (var key in csv_props) {
			headers.push(key);
		}

		var result = [headers];

		locations.forEach(location => {
			result.push([
				location.name,
				location.position[0],
				location.position[1],
				location.pv_category,
				Number(location.pv_data.peak_power),
				location.pv_data.tracking,
				Number(location.pv_data.tilt) || "",
				Number(location.pv_data.azimuth) || "",
				Number(location.pv_data.losses) || ""
			]);
		});
		return result;
	},

	import_locations(exported_locations) {
		var result = [];

		if (!Array.isArray(exported_locations)) throw new Error("Not array given");

		//Get imported headers
		var headers = exported_locations[0];

		//Convert text headers to location properties and check if correct
		var headers_keys = [];

		headers.forEach(header => {
			if (csv_props.hasOwnProperty(header)) {
				headers_keys.push(csv_props[header]);
			} else {
				throw new Error("Not valid CSV header: " + header);
			}
		});

		for (var key in exported_locations) {
			if (key == 0) continue;
			result.push(
				this.convert_row_to_location(exported_locations[key], headers_keys)
			);
		}

		return result;
	},

	convert_row_to_location(row, row_keys) {
		var location = { pv_data: {}, position: [] };

		for (var key in row) {
			var value =
				row[key] != ""
					? row[key]
					: row_keys[key].default
					? row_keys[key].default
					: undefined;
			if (row_keys[key].pv_data) {
				location.pv_data[row_keys[key].slug] = value;
			} else if (row_keys[key].position) {
				location.position[row_keys[key].slug == "lat" ? 0 : 1] = value;
			} else {
				location[row_keys[key].slug] = value;
			}
		}

		//If no tracking added add default
		if (location.pv_data && !location.pv_data.tracking) {
			location.pv_data.tracking = csv_props["Tracking"].default;
		}

		var result = LocationValidator.validate(location);
		if (result.error) {
			throw new Error(result.error.message);
		}

		return location;
	},

	convert_csv_loations(csv_content) {
		const parse = require("csv-parse/lib/sync");
		var converted_data = parse(csv_content);
		return this.import_locations(converted_data);
	},

	convert_locations_to_portfolio(locations) {
		var result = {
			data: {
				chart_data: [],
				total_capacity: 0,
				daily_average_production: null,
				peak_production: null
			},
			export_data: [
				format_csv_headers(["Aggregated PV power forecast"], locations.length),
				format_csv_headers(
					[
						"Time zone: '" +
							Intl.DateTimeFormat().resolvedOptions().timeZone +
							"'"
					],
					locations.length
				)
			]
		};

		//Add csv headers
		var headers = ["Time", "Total PV power [kWp]"];
		var forecasts = {};
		//Format forecasts to process
		for (var key in locations) {
			headers.push(locations[key].name);

			//Sum total capacity
			result.data.total_capacity += Number(locations[key].pv_data.peak_power);

			//Format forecasts
			locations[key].forecasts.forEach(forecast => {
				if (!forecasts[forecast.time]) {
					forecasts[forecast.time] = [0];
				}

				forecasts[forecast.time][0] += forecast.pv_power;

				forecasts[forecast.time][0] =
					Math.round(forecasts[forecast.time][0] * 100) / 100;
				forecasts[forecast.time].push(forecast.pv_power);
			});
		}

		result.export_data.push(
			format_csv_headers(
				[
					"Total Portfolio Power Capacity: " +
						result.data.total_capacity +
						" [kWp]"
				],
				locations.length
			)
		);
		//Add white row
		result.export_data.push(format_csv_headers([], locations.length));

		result.export_data.push(headers);

		var days = [];
		var pv_power_sum = 0;
		//Add forecasts to exported data and chart data
		for (var time in forecasts) {
			var moment_time = moment.unix(time / 1000);
			//Get individual days for daily average production
			var day = moment_time.format("YYYY-MM-DD");
			if (days.indexOf(day) == -1) {
				days.push(day);
			}
			pv_power_sum += forecasts[time][0];

			if (result.data.peak_production < forecasts[time][0])
				result.data.peak_production = forecasts[time][0];

			//Exported data
			var row = [moment_time.format("YYYY-MM-DD HH:mm")];
			forecasts[time].forEach(forecast => {
				row.push(forecast);
			});
			result.export_data.push(row);

			//Chart data
			result.data.chart_data.push({
				time: time,
				pv_power: forecasts[time][0]
			});
		}

		result.data.daily_average_production = parseFloat(
			pv_power_sum / Object.keys(days).length
		).toFixed(0);

		return result;
	}
};

function format_csv_headers(headers, length) {
	for (var i = 0; i < length + 2; i++) {
		if (headers[i]) continue;
		headers.push("");
	}
	return headers;
}
